<div class="coupon_code_page">
    <div class="coupon_code_page_details">
      <div class="row coupan_code">
        <div class="col-md-4 coupon_code_col">
          <label class="coupon_code_heading">Coupon Code:</label>
          <mat-form-field class="col-md-12" appearance="outline">
            <input matInput id="couponCode" type="text" placeholder="Enter coupon code" [formControl]="CouponCode">
          </mat-form-field>
        </div>
        <div class="col-md-4 coupon_code_col">
          <label class="coupon_code_heading">Coupon Type:</label>
          <mat-form-field class="col-md-12" appearance="outline">
            <mat-select id="couponType" placeholder="Select" [formControl]="CouponType"
              (selectionChange)="onCouponTypeChange($event)">
              <!-- <mat-option value="select">Select</mat-option> -->
              <mat-option *ngFor="let type of couponTypes" [value]="type">{{type}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4 coupon_code_col">
          <label class="coupon_code_heading">Validity Till</label>
          <mat-form-field appearance="outline" class="date-picker-field  col-md-12">
            <input matInput [matDatepicker]="picker" [formControl]="ValidityDate" placeholder="Validity Till"
              [min]="todayDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
     
  
      </div>
      <div class="coupon_code_container">
        <div *ngIf="displayCouponTypes.includes('Percentage Off')" class="coupon_code_col" class="col-md-4"
          style="padding-right: 15px;margin-right: 10px;">
          <label class="coupon_code_heading">Percentage Off:</label>
          <mat-form-field appearance="outline" class="col-md-12">
            <input matInput id="percentageOff" type="text" placeholder="Enter Percentage" [formControl]="Percentage">
          </mat-form-field>
        </div>
  
        <div *ngIf="displayCouponTypes.includes('Amount Off')" class="coupon_code_col" class="col-md-4"
          style="padding-right: 15px;">
          <label class="coupon_code_heading">Amount Off:</label>
          <mat-form-field appearance="outline" class="col-md-12">
            <input matInput id="amountOff" type="text" placeholder="Enter Amount" [formControl]="Amount">
          </mat-form-field>
        </div>
  

        <mat-form-field appearance="outline" class="questionary_form_fields">
          <textarea  [formControl]="Description" matInput placeholder="Description"></textarea>
      </mat-form-field>
      
      </div>
      <div class="">
        <button (click)="toSubmit()" class="coupon_code_button">Submit</button>
      </div>
    </div>
  </div>
  